import classNames from 'classnames';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@feathr/components';

import LeftPanelTabsBeta from './LeftPanelTabs.beta';

import * as styles from './LeftPanelTabs.css';

interface IProps {
  activeTab: 'settings' | 'design';
  handleTabClick: (tab: 'settings' | 'design') => void;
}

function LeftPanelTabs({ activeTab, handleTabClick }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  function handleClickSettings(): void {
    handleTabClick('settings');
  }

  function handleClickDesign(): void {
    handleTabClick('design');
  }

  // TODO: MVP will only have one tab, "Donation Amounts"
  return (
    <div className={styles.root}>
      <button
        className={classNames(styles.tab, styles.left, {
          [styles.active]: activeTab === 'settings',
        })}
        onClick={handleClickSettings}
      >
        <Text.LargeSemibold
          className={classNames({
            [styles.inactive]: activeTab !== 'settings',
          })}
        >
          {t('Donation Form')}
        </Text.LargeSemibold>
      </button>
      <button
        className={classNames(styles.tab, {
          [styles.active]: activeTab === 'design',
        })}
        onClick={handleClickDesign}
        type={'button'}
      >
        <Text.LargeSemibold
          className={classNames({
            [styles.inactive]: activeTab !== 'design',
          })}
        >
          {t('Design')}
        </Text.LargeSemibold>
      </button>
    </div>
  );
}

LeftPanelTabs.Beta = LeftPanelTabsBeta;

export default LeftPanelTabs;
